import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import { FULLPAGE_ROUTES, resolveRouteKey } from '../Router/routes';

export const MainDiv = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'location' && prop !== 'customerId' && prop !== 'routes',
})(({ location, customerId, routes }) => ({
  flex: '1 1 auto',
  height: '80%',
  padding:
    routes?.find(
      (route) =>
        `/${route.target}` === location &&
        FULLPAGE_ROUTES.includes(resolveRouteKey(route))
    ) ||
    location === '/401' ||
    customerId
      ? 'unset'
      : '16px',
}));

export const StyledList = styled(List)(({ theme }) => ({
  // selected and (selected + hover) states
  '&& .Mui-selected, && .Mui-selected:hover': {
    borderRadius: '10px',
    '&': {
      color: '#fff',
      backgroundImage: theme.custom.gradients.brand,
      boxShadow: '0 2px 6px rgba(29, 91, 157, .24)',
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.white.main,
      background: 'transparent',
    },
  },
}));
